import request from '@/plugins/axios'

export default {
    login(data) {
        return request.post('/Yunos/User/Login', data)
    },
    getInfo(phone) {
        return request.get(`/Yunos/User/UserAccountInfo?phone=${phone}`)
    },
	// 获取企业员工信息
	getCompEmployeeInfo(compId) {
		return request.get(`/Yunos/Employee/CompEmployeeInfo`)
	}
}